import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

let mobileOpen = (window.innerWidth < 960) ? true : false; //console.log("mobileOpen="+mobileOpen);
let PMTMLabel_fontSize = mobileOpen ? "0.75rem" : "0.75rem";
let logo_width  = mobileOpen ? "80px" : "100px";
let logo_height = mobileOpen ? "80px" : "100px";
let viewRN_key_fontSize = mobileOpen ? "0.88rem" : "1rem";
let viewRN_val_fontSize = mobileOpen ? "0.88rem" : "1rem";

const BillsFavoritesDetailStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  logo: {
    margin: "0rem 0",
    "& img": {
    //width   : "75%",
      width   : logo_width,//"100px",
      height  : logo_height,//"100px",
      display : "block",
      margin  : "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  companyIcon: {
    margin: "0rem 0",
    "& img": {
    //width   : "75%",
      width   : logo_width,//"100px",
      height  : logo_height,//"100px",
      display : "block",
      margin  : "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  senderRecipientDetails_flagimage: {
    margin: "0.25rem 0",
    "& img": {
      // width: "75%",
      display: "block",
      margin: "auto"
    },
    // "& span": {
    //   width: "100px",
    //   height: "1px",
    //   borderBottom: "3px solid " + ts_main[3],
    //   display: "block",
    //   margin: "1rem auto"
    // }
  },
  senderRecipientDetails_image: {
    margin: "0.25rem 0",
    "& img": {
      // width: "75%",
      display: "block",
      margin: "auto"
    },
    // "& span": {
    //   width: "100px",
    //   height: "1px",
    //   borderBottom: "3px solid " + ts_main[3],
    //   display: "block",
    //   margin: "1rem auto"
    // }
  },
  senderRecipientDetails_label: {
    marginTop        : 5,
    marginBottom     : 5,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },

  label1: {
    fontSize     : "1rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "300",
    color        : "#303030",
    textAlign    : "left",
    "vertical-align":"middle",
  },
  BillsFavoritesDetail_lbl_status: {
    marginTop        : 30,
    marginBottom     : 10,
    fontSize         : "1.6rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  BillsFavoritesDetail_lbl_date: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "0.9rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  viewRN_key: {
    fontSize         : viewRN_key_fontSize,//"1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
    "word-wrap"      : "break-word",
  },
  viewRN_val: {
    fontSize         : viewRN_val_fontSize,//"1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "right",
    "vertical-align" : "middle",
    "word-wrap"      : "break-word",
  },
  BillsFavoritesDetail_lbl_select_your_bank: {
    marginTop        : 10,
    marginBottom     : 2,
    fontSize         : "0.75rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "800",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  //--------
  //DropDown
  //--------
  //-------
  //Buttons
  //-------
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  backButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#0000ff",
    backgroundColor  : "rgba(255, 255, 255, 1.0)",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
    "&:focus"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
  //------------
  //viewSteps3/4
  //------------
  viewSteps3Image: {
    margin: "0rem 0",
    "& img": {
      width: "75%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  viewSteps4Image: {
    margin: "0rem 0",
    "& img": {
      width: "75%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  viewSteps4ImageDots: {
    "& img": {
      width: "200%",
      display: "block",
      margin: "auto"
    },
  },
  viewSteps3Label: {
    fontSize     : "0.75rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "200",
    color        : "#303030",
    textAlign    : "center",
    "vertical-align":"middle",
  },
  viewSteps4Label: {
    fontSize     : "0.75rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "200",
    color        : "#303030",
    textAlign    : "center",
    "vertical-align":"middle",
  },
  textField1: {
    marginTop        : 0,
    marginBottom     : 0,
    input            : { color : "303030" }
  },
  BillsFavoritesDetail_lbl_cardHolderName: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "0.85rem",
    fontFamily       : '"Helvetica"',
  //fontWeight       : "bold",
    color            : "#35B6B4",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  BillsFavoritesDetail_lbl_card12: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.85rem",
    fontFamily       : '"Helvetica"',
  //fontWeight       : "bold",
    color            : "#35B6B4",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //---------------
  //PleaseWaitPopup
  //---------------
  pleaseWaitPopup: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    overflow         : "hidden",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },

  //----------------------------
  //PaymentMethod/TransferMethod
  //----------------------------
  PMTMImage: {
    margin: "0rem 0",
    "& img": {
      width: "50px",
      height: "50px",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  PMTMLabel: {
    fontSize         : PMTMLabel_fontSize,//"0.75rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" :"middle",
    margin           : "0px -5px !important",
    padding          : "0px !important",
  },
});

export default BillsFavoritesDetailStyle;
